export default __webpack_public_path__ + "static/media/Microsoft_To_Do_128x128.d73361a6.webp";